export default __webpack_public_path__ + "static/media/rejectedRedIcon.db63e7db.svg";